class Tabs {
    constructor(tab) {
        this.tab = tab;
        this.navTabs = this.tab.querySelector(".nav-tabs");
        this.offset = 40;
        this.timeout = undefined;
        this.duration = 300;

        // Init
        this.init();
    }

    events() {
        const _this = this;

        this.navTabs.addEventListener("click", function (event) {
            let navLink = event.target.closest(".nav-link");

            if (Boolean(navLink)) {
                _this.alignTabHorizontal(navLink);
            }
        });

        this.navTabs.addEventListener("scroll", function (event) {
            clearTimeout(_this.timeout);

            _this.timeout = setTimeout(function () {
                _this.checkControlButtons(event.target);
            }, _this.duration);
        });

        window.addEventListener("resize", function () {
            clearTimeout(_this.timeout);

            _this.timeout = setTimeout(function () {
                _this.checkControlButtons(_this.navTabs);
            }, _this.duration);
        });

        jQuery(".nav-tabs-control-prev").on("click", function (event) {
            let button = null;

            jQuery.each(jQuery(_this.navTabs).find(".nav-link"), function (index, element) {
                if (jQuery(element).position().left >= 0) {
                    return false;
                }

                button = element;
            });

            _this.animate(
                jQuery(_this.navTabs).scrollLeft() +
                    jQuery(button).position().left -
                    (jQuery(_this.navTabs).outerWidth() - jQuery(button).outerWidth())
            );
        });

        jQuery(".nav-tabs-control-next").on("click", function (event) {
            let button = null;

            jQuery.each(jQuery(_this.navTabs).find(".nav-link"), function (index, element) {
                if (
                    jQuery(element).position().left <= jQuery(_this.navTabs).outerWidth() &&
                    jQuery(element).position().left + jQuery(element).outerWidth() > jQuery(_this.navTabs).outerWidth()
                ) {
                    button = element;
                }
            });

            _this.animate(jQuery(_this.navTabs).scrollLeft() + jQuery(button).position().left);
        });
    }

    checkControlButtons(target) {
        if (target.scrollLeft === 0) {
            jQuery(".nav-tabs-control-prev").addClass("nav-tabs-control-prev--disabled");
        } else {
            jQuery(".nav-tabs-control-prev").removeClass("nav-tabs-control-prev--disabled");
        }

        if (target.scrollLeft + target.clientWidth === target.scrollWidth) {
            jQuery(".nav-tabs-control-next").addClass("nav-tabs-control-prev--disabled");
        } else {
            jQuery(".nav-tabs-control-next").removeClass("nav-tabs-control-prev--disabled");
        }
    }

    alignTabHorizontal(tab) {
        const _this = this;

        let $tabParent = jQuery(tab).parent();
        let tabParentRect = $tabParent[0].getBoundingClientRect();
        let tabRect = tab.getBoundingClientRect();

        if (tabRect.right > tabParentRect.right) {
            _this.animate(
                _this.offset + $tabParent[0].scrollLeft + (tabRect.width - (tabParentRect.right - tabRect.left))
            );
        } else if (tabRect.left - tabParentRect.left < 0) {
            _this.animate(-_this.offset + $tabParent[0].scrollLeft + (tabRect.left - tabParentRect.left));
        }
    }

    animate(scrollLeft) {
        const _this = this;

        jQuery(this.navTabs).animate(
            {
                scrollLeft: scrollLeft,
            },
            _this.duration,
            function () {
                jQuery(this).clearQueue();
            }
        );
    }

    init() {
        this.events();
        this.checkControlButtons(this.navTabs);
    }
}

export { Tabs };
